package com.kanati.shared.district

import com.kanati.shared.consumer.ConsumerAppRuntimeSettings
import kotlinx.serialization.Serializable

@Serializable
data class TaxRule(
    val name: String,
    val rateBps: Int,
)

@Serializable
data class DistrictSettingsResponse(
    val districtId: String,
    val defaultTaxRateBps: Int,
    val taxRules: List<TaxRule>,
    val consumerApp: ConsumerAppRuntimeSettings? = null,
)

@Serializable
data class UpdateDistrictSettingsRequest(
    val defaultTaxRateBps: Int,
    val consumerApp: ConsumerAppRuntimeSettings? = null,
)
